import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customSort',
  standalone: true
})
export class CustomSortPipe implements PipeTransform {

  transform(items: any[], selectedId: string): any[] {
    if (!items || !selectedId) {
      return items;
    }

    // Find the item with the specified _id
    const selectedItem = items.find(item => item._id === selectedId);

    if (!selectedItem) {
      return items;
    }

    // Remove the selected item from the original array
    const filteredItems = items.filter(item => item._id !== selectedId);

    // Place the selected item at the top of the array
    return [selectedItem, ...filteredItems];
  }


}
